import styled, { css } from 'styled-components';
import { ValueOf } from 'ia-react-core/~/interfaces/ValueOf';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';

export const StyledBox = styled.div<{
  scheme: ValueOf<typeof COLOR_SCHEMES>;
  white: boolean;
}>`
  padding: 16px;
  margin-bottom: 16px;
  border-radius: ${({ theme }) => theme?.Box?.borderRadius};
  background: ${({ scheme, theme, white }) => {
    if (white) return theme.colors.white;
    if (scheme === COLOR_SCHEMES.LIGHT) return theme.colors.smoothGray;
    if (scheme === COLOR_SCHEMES.SHADE) return theme.colors.white;
    return 'rgba(255, 255, 255, 0.15)';
  }};

  ${({ white, scheme, theme }) => {
    if (white && scheme === COLOR_SCHEMES.LIGHT) {
      return css`
        border: 1px solid ${theme.colors.smoothGray};
      `;
    }
    return undefined;
  }}
  
  &:last-child {
    margin-bottom: 0;
  }
`;
